import React from "react";
import { cn } from "@/lib/utils";

/**
 * OfferNest brand logo (`/logo.png` — orange nest with price-tag mark + wordmark
 * on a dark canvas). Both `mark` and `lockup` variants render this same asset
 * so the brand appearance is identical everywhere the logo shows up.
 *
 * `size` = pixel HEIGHT. Width auto.
 */
export const Logo = ({ size = 40, variant = "mark", className }) => {
    // `variant` and `showWordmark`/`dark` are kept in the signature purely for
    // backwards compatibility with existing call-sites — they don't affect the
    // rendered asset anymore.
    void variant;
    return (
        <img
            src="/logo.png"
            alt="OfferNest"
            style={{ height: size }}
            className={cn("w-auto select-none object-contain", className)}
            data-testid="offernest-logo"
        />
    );
};

export default Logo;
